module.exports = __webpack_public_path__ + "img/searchHomeIcon.b67d5614.svg";